import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import axios from "axios";
import JSZip from "jszip";
import { jsPDF } from "jspdf";
import Barcode from "react-barcode";
import DocViewer from "@cyntler/react-doc-viewer";

import { MdOutlinePictureAsPdf, MdOutlineEdit } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { PiX, PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline, IoClose } from "react-icons/io5";
import { BsDownload } from "react-icons/bs";

import BrowseUploadButton from "../../common/button/browseUploadButton";
import PrintDownloadButton from "../../common/button/printDownloadButton";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import FileUploader from "../../common/fileupload";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import CancelButton from "../../common/button/cancelButton";
import PreRequisiteModal from "./preRequisiteModal";
import Prerequesite from "./preRequesite";
import MasterModel from "../createMaster/masterModel";
import CreateMasterModal from "../masterForm/modals/createMasterModal";
import modifyWordFileCard from "../../common/wordFilemodify";
import image from "../../assets/images/image.png";
import pdf from "../../assets/images/uploads/pdf.png";

import masterFormsActions from "../../redux/masterForms/actions";
import masterActions from "../../redux/master/actions";
import commonActions from "../../redux/common/actions";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import { NumbersValidation } from "../../utils/validation";
import { API_URL } from "../../utils/constants";
import { styled, Switch } from "@mui/material";
import capRegistrationActions from "../../redux/capRegistration/actions";

export default function AddCapCourse() {
  const navigate = useNavigate();
  const location = useLocation();
  const now = new Date();
  const dispatch = useDispatch();
  const today = new Date();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    resetForm,
    formState: { errors },
  } = useForm();

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const { courseList } = useSelector((state) => state.masterReducer);
  const { capDocuments } = useSelector((state) => state.capReducer);
  const { capCourseList } = useSelector((state) => state.capReducer);

  console.log("capDocuments--", capDocuments);

  const [searchParams] = useSearchParams();
  const capid = searchParams.get("id");

  const filteredCapCourse = capid
    ? capCourseList?.find((item) => item?.capcourseid == capid)
    : null; 

  console.log("filteredCapCourse---", filteredCapCourse);
  console.log("capCourseList---", capCourseList);

  useEffect(() => {
    dispatch({
      type: capRegistrationActions.GET_ALL_CAP_COURSE,
    });
    dispatch({
      type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT,
    });
  }, []);

  const handleAddCourse = (data) => {
    console.log("addcoursedata--", data);

    dispatch({
      type: capRegistrationActions.CREATE_CAP_COURSE,
      payload: {
        data: data,
        navigate: navigate,
        resetForm: resetForm,
        reset: reset,
      },
    });
  };
  const handleUpdateCourse = (data) => {
    console.log("addcoursedata--", data);

    data["capcourseid"] = capid;

    dispatch({
      type: capRegistrationActions.UPDATE_CAP_COURSE,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };

  const selectedCategory = watch("coursecategory");

  const filteredCourses = courseList?.all?.filter(
    (course) => parseInt(course.coursecategoryid) == parseInt(selectedCategory)
  );

  console.log("courseList----", courseList);
  console.log("filteredCourses----", filteredCourses);
  console.log("selectedCategory----", selectedCategory);

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    setValue("exams", []);
  }, [dispatch, selectedCategory]);

  // const documentOptions = [
  //   { id: 1, label: "10, +2 marksheet" },
  //   { id: 2, label: "CET/NEET Score card" },
  //   { id: 3, label: "Identity proof" },
  //   { id: 4, label: "Domicile certificate" },
  // ];

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleChange = (event) => {
    setSelectedDocs(event.target.value);
  };

  const capDocumentOptions =
    capDocuments?.map((doc) => ({
      id: parseInt(doc.documenttypeid),
      label: doc.documenttype,
    })) || [];

  const handleFileUpload = (e, id, documenttype, status, isactive,coursenotes) => {
    dispatch({
      type: capRegistrationActions.UPLOAD_DOCUMENT,
      payload: {
        documenttypeid: parseInt(id),
        file: e.target.files[0],
        userid: parseInt(backofficeTokenDetails?.id),
        documenttype: documenttype,
        status: status,
        isactive: isactive,
        coursenotes : coursenotes
      },
    });
  };

  const handleRemoveFile = (id, documenttype, status, isactive,coursenotes) => {
    console.log("documentstatus ", status);
    console.log("documenttype in rem", documenttype);

    dispatch({
      type: capRegistrationActions.REMOVE_DOCUMENT,
      payload: {
        documenttypeid: parseInt(id),
        userid: parseInt(backofficeTokenDetails?.id),
        documenttype: documenttype,
        status: status,
        isactive: isactive,
        coursenotes : coursenotes
      },
    });
  };

  const getDocLabel = (id) => {
    return capDocumentOptions.find((doc) => doc.id === id)?.label || "";
  };

  const setCapCourseValues = (filteredCapCourse) => {
    if (!filteredCapCourse) return;

    setValue("coursecategory", filteredCapCourse.coursecategory?.toString());
    setValue("exams", filteredCapCourse.exams?.toString());
    setValue("coursename", filteredCapCourse.coursename);
    setValue("verificationType", filteredCapCourse?.verificationtype);
    console.log(getValues("verificationType"), "verificationType---");

    setValue("regstartdate", dayjs(filteredCapCourse.regstartdate));
    setValue("regenddate", dayjs(filteredCapCourse.regenddate));
    setValue("latefeestartdate", dayjs(filteredCapCourse.latefeestartdate));
    setValue("latefeeenddate", dayjs(filteredCapCourse.latefeeenddate));

    // Add more fields below if needed
    setValue("generalamount", filteredCapCourse.generalamount);
    setValue("generalextraamount", filteredCapCourse.generalextraamount);
    setValue("lategeneralamount", filteredCapCourse.lategeneralamount);
    setValue("latenongeneralamount", filteredCapCourse.latenongeneralamount);
    setValue("nongeneralamount", filteredCapCourse.nongeneralamount);
    setValue("nongeneralextraamount", filteredCapCourse.nongeneralextraamount);
    setValue("payumerchantid", filteredCapCourse.payumerchantid);
    setValue("payusaltkey", filteredCapCourse.payusaltkey);
    setValue("billdeskmerchantid", filteredCapCourse.billdeskmerchantid);
    setValue("billdeskclientid", filteredCapCourse.billdeskclientid);
    setValue("billdesksecurityid", filteredCapCourse.billdesksecurityid);
    setValue(
      "requireddocuments",
      filteredCapCourse.requireddocuments?.map(String)
    );
  };

  useEffect(() => {
    if (filteredCapCourse) {
      setCapCourseValues(filteredCapCourse);
    }
  }, [filteredCapCourse]);

  return (
    <>
      <Typography variant="h5" mb={3}>
        Course Information
      </Typography>

      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.coursecategory} fullWidth>
            <InputLabel htmlFor="coursecategory">
              <span>
                Select UG/PG
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="coursecategory"
              id="demo-simple-select"
              helperText={errors?.coursecategory?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
              error={!!errors.coursecategory}
              rules={{ required: "Course Category is required" }}
              control={control}
              defaultValue="" // Initial value if any
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  label={
                    <span>
                      Select UG/PG
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  {...field}
                  error={!!errors.coursecategory}
                  helperText={errors.coursecategory?.message}
                  FormHelperTextProps={{
                    style: { margin: 0 },
                  }}

                  // defluaultValue=""
                  // placeholder="Select Course Category"
                >
                  <MenuItem key="" value="" disabled>
                    Select UG/PG
                  </MenuItem>
                  {/* 
                  {courseCategoryList &&
                    courseCategoryList.all.map((obj) => {
                      return (
                        <MenuItem
                          key={obj.coursecategoryid.toString()}
                          value={obj.coursecategoryid.toString()}
                        >
                          {obj.coursecategory}
                        </MenuItem>
                      );
                    })} */}
                  <MenuItem
                    value={1}
                    // onClick={setValue("exams",[])}
                  >
                    PG
                  </MenuItem>{" "}
                  <MenuItem
                    value={6}
                    // onClick={setValue("exams",[])}
                  >
                    UG
                  </MenuItem>
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.coursecategory?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.exams} fullWidth>
            <InputLabel htmlFor="exams">
              <span>
                Select Exam
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="exams"
              control={control}
              rules={{ required: "Course is required" }}
              defaultValue={[]}
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  multiple
                  value={Array.isArray(field.value) ? field.value : []}
                  onChange={(e) => {
                    const selectedValues = e.target.value;
                    const validValues = selectedValues.filter(
                      (val) => val !== null && val !== undefined
                    );
                    const uniqueValues = Array.from(
                      new Set(validValues.map((val) => val?.toString()))
                    );
                    field.onChange(uniqueValues);
                  }}
                  label={
                    <span>
                      Select Course
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {(Array.isArray(selected) ? selected : []).map(
                        (value) => {
                          const selectedCourse = filteredCourses?.find(
                            (course) =>
                              parseInt(course.courseid) === parseInt(value)
                          );
                          return (
                            <Chip
                              key={value}
                              label={selectedCourse?.coursename || "Unknown"}
                            />
                          );
                        }
                      )}
                    </Box>
                  )}
                  error={!!errors.exams}
                >
                  <MenuItem key="" value="" disabled>
                    Select Course
                  </MenuItem>
                  {filteredCourses &&
                    filteredCourses?.map((course) => (
                      <MenuItem
                        key={course.courseid?.toString()}
                        value={course.courseid?.toString()}
                      >
                        {course.coursename}
                      </MenuItem>
                    ))}
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.exams?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("coursename", {
              required: "Course name is required",
              // validate: (value) => {
              //   return value
              //     ? /^\d+$/.test(value) || "Course Code must be numeric"
              //     : true;
              // },
            })}
            InputLabelProps={{
              shrink: !!watch("coursename"),
            }}
            error={!!errors.coursename}
            helperText={errors.coursename?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Course name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("coursename", value);
              trigger("coursename");
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl component="fieldset" error={!!errors.verificationType}>
            <Controller
              name="verificationType"
              control={control}
              rules={{ required: "Verification type is required" }}
              render={({ field }) => (
                <RadioGroup
                  row
                  {...field}
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio size="small" />}
                    label="Manual Verification"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio size="small" />}
                    label="Online Verification"
                  />
                  <FormControlLabel
                    value="3"
                    control={<Radio size="small" />}
                    label="No Verification"
                  />
                </RadioGroup>
              )}
            />
            {errors.verificationType && (
              <FormHelperText>{errors.verificationType.message}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>

      <Typography variant="h5" mb={3}>
        Date Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <Controller
            name="regstartdate"
            control={control}
            rules={{
              required: "Registration start date is required",
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Registration Start Date
                      <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span>
                    </span>
                  }
                  format="DD/MM/YYYY"
                  disablePast
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.regstartdate,
                      helperText: errors.regstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="regenddate"
            control={control}
            rules={{
              required: "Registration end date is required",
              validate: {
                validDate: (date) => {
                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be a today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Registration End Date
                      <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span>
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.regenddate,
                      helperText: errors.regenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="latefeestartdate"
            control={control}
            rules={{
              required: "Late Fee Registration start date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Late Fee Registration Start Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.latefeestartdate,
                      helperText: errors.latefeestartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="latefeeenddate"
            control={control}
            rules={{
              required: "Late Fee Registration end date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Late Fee Registration End Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("latefeestartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.latefeeenddate,
                      helperText: errors.latefeeenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </Grid>

      <Typography variant="h5" mb={3}>
        Payment Information
      </Typography>
      <Box sx={{ margin: "15px" }}></Box>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("generalamount", {
              required: "Payment for general Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("generalamount"),
            }}
            error={!!errors.generalamount}
            helperText={errors.generalamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Amount
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("nongeneralamount", {
              required: "Payment for non general Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("nongeneralamount"),
            }}
            error={!!errors.nongeneralamount}
            helperText={errors.nongeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Amount
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("lategeneralamount", {
              required: "payment for general late fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("lategeneralamount"),
            }}
            error={!!errors.lategeneralamount}
            helperText={errors.lategeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Late Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("latenongeneralamount", {
              required: "payment for non general late fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("latenongeneralamount"),
            }}
            error={!!errors.latenongeneralamount}
            helperText={errors.latenongeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Late Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("generalextraamount", {
              required: "payment for general extra fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("generalextraamount"),
            }}
            error={!!errors.generalextraamount}
            helperText={errors.generalextraamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Extra Fee Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("nongeneralextraamount", {
              required: "payment for non general extra fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("nongeneralextraamount"),
            }}
            error={!!errors.nongeneralextraamount}
            helperText={errors.nongeneralextraamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Extra Fee Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
      </Grid>
      <Typography variant="h5" mb={3}>
        Billdesk Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdeskmerchantid", {
              required: "Merchant Id For Billdesk is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdeskmerchantid"),
            }}
            error={!!errors.billdeskmerchantid}
            helperText={errors.billdeskmerchantid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Merchant Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdesksecurityid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdesksecurityid"),
            }}
            error={!!errors.billdesksecurityid}
            helperText={errors.billdesksecurityid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Security Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdeskclientid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdeskclientid"),
            }}
            error={!!errors.billdeskclientid}
            helperText={errors.billdeskclientid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Client Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
      </Grid>
      <Typography variant="h5" mb={3}>
        PayU Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("payumerchantid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("payumerchantid"),
            }}
            error={!!errors.payumerchantid}
            helperText={errors.payumerchantid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Merchant Id For PayU
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("payusaltkey", {
              required: "Merchant Id For Billdesk is required",
            })}
            InputLabelProps={{
              shrink: !!watch("payusaltkey"),
            }}
            error={!!errors.payusaltkey}
            helperText={errors.payusaltkey?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Salt Key For PayU
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mb={3}>
        <Grid container spacing={2} sx={{ mt: 2, px: 2, alignItems: "center" }}>
          <Grid item xs={12}>
            <Typography variant="h6">Required documents</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controller
              name="requireddocuments"
              control={control}
              defaultValue={[]}
              rules={{ required: "Please select at least one document" }}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  error={!!errors.requireddocuments}
                >
                  <Select
                    multiple
                    displayEmpty
                    value={field.value.map(String)} // convert to string
                    onChange={(e) =>
                      field.onChange(
                        typeof e.target.value === "string"
                          ? e.target.value.split(",")
                          : e.target.value
                      )
                    }
                    input={<OutlinedInput />}
                    renderValue={(selected) =>
                      selected.length === 0
                        ? "Add document"
                        : selected
                            .map((val) => getDocLabel(parseInt(val)))
                            .join(", ")
                    }
                    MenuProps={{
                      PaperProps: { style: { maxHeight: 200 } },
                      disableScrollLock: true,
                    }}
                  >
                    {capDocumentOptions.map((doc) => (
                      <MenuItem key={doc.id} value={String(doc.id)}>
                        {doc.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {errors.requireddocuments && (
                    <FormHelperText>
                      {errors.requireddocuments.message}
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={12}>
            {(useWatch({ control, name: "requireddocuments" }) || []).map(
              (docId) => {
                const doc = capDocuments.find(
                  (d) => parseInt(d.documenttypeid) == docId
                );
                if (!doc) return null;
                return (
                  <Box key={docId} sx={{ mb: 2 }}>
                    <FileUploader
                      Filename={doc.documenttype}
                      fileUrl={doc?.sampleurl}
                      handleUpload={(e) =>
                        handleFileUpload(
                          e,
                          doc.documenttypeid,
                          doc.documenttype,
                          doc?.status,
                          doc.isactive,
                          doc.coursenotes
                        )
                      }
                      handleRemoveFile={() =>
                        handleRemoveFile(
                          doc.documenttypeid,
                          doc.documenttype,
                          doc?.status,
                          doc.isactive,
                          doc.coursenotes
                        )
                      }
                    />
                  </Box>
                );
              }
            )}
          </Grid>
        </Grid>

        {/* Log integer array if needed */}
        {/* <pre>{JSON.stringify(selectedDocs)}</pre> */}

        <Grid
          item
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        >
          <BackButton
            handleBack={() =>
              navigate(
                `/${Cookies.get(
                  "mhet_mst_project"
                )}/cap-course-management?page=capcourselist`
              )
            }
          />
          <BluePrimaryButton
            handleSubmit={handleSubmit(
              capid ? handleUpdateCourse : handleAddCourse
            )}
            title={capid ? "Update" : "Submit"}
          />
        </Grid>
      </Grid>
    </>
  );
}
